var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8C9196",
  fillRule: "evenodd",
  d: "M39 15c0-4.963-4.037-9-9-9s-9 4.037-9 9v8h18zm6 8v-8c0-8.284-6.716-15-15-15S15 6.716 15 15v8h-5a2 2 0 0 0-2 2v20c0 8.284 6.716 15 15 15h14c8.284 0 15-6.716 15-15V25a2 2 0 0 0-2-2zM30 50a3 3 0 0 1-3-3V35a3 3 0 1 1 6 0v12a3 3 0 0 1-3 3",
  clipRule: "evenodd"
})));
export { SvgLock as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.cbd03bf7.svg";